// =====================================
//
//   首頁 全部商品 電梯
//   Author: Gray
//   createtime: 2017 / 04 / 25
//   Author: Gray
//   updatetime: 2017 / 04 / 25
//
// =====================================

window.InifECApp.directive('pdtclassElevator',  ['$timeout', '$state', function($timeout, $state) {

    var _dir = {};

    var link = function(scope, element, attrs) {

        var $window = $(window),
            $elevatorbar = element.find('.elevator-bar'),
            $contents = element.find('[pdtclass-scroll-content]'),
            $scrollBtns = element.find('[pdtclass-scroll-to]'),
            isInit = false;

        var _scrollHandler = function(event) {

            if(!isInit) {
                $elevatorbar = element.find('.elevator-bar');
                $contents = element.find('[pdtclass-scroll-content]');
                $scrollBtns = element.find('[pdtclass-scroll-to]');
                isInit = true;
            }

            if($elevatorbar.length == 0 || $contents.length == 0 || $scrollBtns.length == 0) {
                return;
            }

            var scrollTop = $window.scrollTop();

            if (scope.$$phase) {
                scope.$eval(function() {

                    $scrollBtns.removeClass('active');
                    for(var i = $contents.length - 1 ; i >= 0 ; i--) {
                        var $content = $($contents[i]),
                            offset = $content.offset(),
                            height = $content.outerHeight();

                        if(scrollTop - offset.top + scope.differ >= 0) {
                            $($scrollBtns[i]).addClass('active');
                            break;
                        }
                    }

                    if(scope.isDefaultActiveFirst) {
                        var $content = $($contents[0]),
                            offset = $content.offset(),
                            height = $content.outerHeight();

                        if(scrollTop <= offset.top) {
                            $($scrollBtns[0]).addClass('active');
                            return;
                        }
                    }

                    if((window.innerHeight + scrollTop) >= document.body.offsetHeight) {
                        $scrollBtns.removeClass('active');
                        $($scrollBtns[$scrollBtns.length - 1]).addClass('active');
                    }
                });
            } else {
                scope.$apply(function() {

                    $scrollBtns.removeClass('active');
                    for(var i = $contents.length - 1 ; i >= 0 ; i--) {
                        var $content = $($contents[i]),
                            offset = $content.offset(),
                            height = $content.outerHeight();

                        if(scrollTop - offset.top + scope.differ >= 0) {
                            $($scrollBtns[i]).addClass('active');
                            break;
                        }
                    }

                    if(scope.isDefaultActiveFirst) {
                        var $content = $($contents[0]),
                            offset = $content.offset(),
                            height = $content.outerHeight();

                        if(scrollTop <= offset.top) {
                            $($scrollBtns[0]).addClass('active');
                            return;
                        }
                    }

                    if((window.innerHeight + scrollTop) >= document.body.offsetHeight) {
                        $scrollBtns.removeClass('active');
                        $($scrollBtns[$scrollBtns.length - 1]).addClass('active');
                    }
                });
            }
        }

        var scrollHandler = function(event) {

            throttle(_scrollHandler(event), 10);
        }

        var stopEvent = function() {

            $(window).off('scroll.pdtclasselevator'+attrs.elevatorState);
            $(window).off('resize.pdtclasselevator'+attrs.elevatorState);
        }

        var reset = function() {
var $navwrapper; // bundler：原本是隱式全域（沒有 var），strict mode 會 ReferenceError

            $navwrapper = $('#product-nav-wrapper');
            $elevatorbar = element.find('.elevator-bar');
            $contents = element.find('[pdtclass-scroll-content]');
            $scrollBtns = element.find('[pdtclass-scroll-to]');
        }

        var init = function() {

            reset();

            $(window).off('scroll.pdtclasselevator'+attrs.elevatorState).on('scroll.pdtclasselevator'+attrs.elevatorState, scrollHandler);

            $(window).off('resize.pdtclasselevator'+attrs.elevatorState).on('resize.pdtclasselevator'+attrs.elevatorState, function() {
                reset();
            });

            $scrollBtns.off('click').on('click', function(event) {
                var scrollTo = $(this).attr("pdtclass-scroll-to");
                if(scrollTo) {
                    var $content = element.find('[pdtclass-scroll-content='+scrollTo+']');
                    if($content.length == 0) {
                        return;

                    }

                    var offset = $content.offset();
                    $('html, body').stop().animate({scrollTop: offset.top - scope.differ + 1}, 200);
                }
            });

            $timeout(function() {
                $(window).trigger('scroll.pdtclasselevator'+attrs.elevatorState);
            })
        }

        scope.$on('$destroy', function() {
            stopEvent();
        });

        // scope.$watchCollection('pdtclassElevator', function(newValue, oldValue) {
        //     if(!newValue || newValue.length == 0) {
        //         init();
        //     }
        // });

        scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

            $timeout(function() {
                $(window).trigger('scroll.pdtclasselevator'+attrs.elevatorState);
            })
        });

        scope.$watchGroup(['pdtclassElevator', 'pdtclassIsLoaded'], function(newValues, oldValues) {

            if(!newValues[0] || newValues[0].length == 0) {
                return;
            }

            if(newValues[1]) {
                init();
            } else if(!newValues[1]) {
                stopEvent();
            }
        });
    }

    _dir.restrict = 'A';
    _dir.scope = {
        pdtclassElevator: '=',
        pdtclassIsLoaded: '=',
        differ: '=',
        isDefaultActiveFirst: '=',
    };
    _dir.link = link;

    return _dir;
}]);